import { firestore } from "./firebase";

export default async function searchInCollection(query, collection) {
    if (!query || !collection) return [];

    const terms = query.toLowerCase().split(/[^a-z]+/).filter(term => term.length > 0);

    const q = firestore.collection(collection).where('search_index', 'array-contains-any', terms);
    const snapshot = await q.get();
    if (snapshot.empty) return [];

    const results = snapshot.docs.map(doc => ({
        objectID: doc.id,
        ...doc.data()
    }));

    results.sort((a, b) => {
        const aRank = searchResultRank(a, query);
        const bRank = searchResultRank(b, query);
        return bRank - aRank; // Sort descending by rank
    });

    return results;
}

function searchResultRank(item, query) {
    if (!query) return 0;

    const terms = query.split(/[^a-z]+/);
    let rank = 0;

    for (const term of terms) {
        if (item.search_index?.includes(term)) {
            rank += 10;
        }
    }

    rank += item.event_count??0;

    return rank;
}